import {
  ADD_BANK_DETAILS_STARTED,
  ADD_BANK_DETAILS_COMPLETED,
  ADD_BANK_DETAILS_ERROR,
  ADD_PROFILE_DETAILS_STARTED,
  ADD_PROFILE_DETAILS_COMPLETED,
  ADD_PROFILE_DETAILS_ERROR,
  FETCH_PROFILE_DETAILS_STARTED,
  FETCH_PROFILE_DETAILS_COMPLETED,
  FETCH_PROFILE_DETAILS_ERROR,
  EDIT_PROFILE_DETAILS_STARTED,
  EDIT_PROFILE_DETAILS_COMPLETED,
  EDIT_PROFILE_DETAILS_ERROR
} from '../actionTypes/profileActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  profile: {}
};

function profileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_BANK_DETAILS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_BANK_DETAILS_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_BANK_DETAILS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_PROFILE_DETAILS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_PROFILE_DETAILS_COMPLETED: {
      return {
        ...state,
        profile: {...action.payLoad},
        submitted: false,
        success: true
      };
    }
    case ADD_PROFILE_DETAILS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_PROFILE_DETAILS_STARTED: {
      return{
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_PROFILE_DETAILS_COMPLETED: {
      if (action.payLoad) {
        return{
          ...state,
          profile: {...action.payLoad},
          submitted: false,
          error: true
        };
      }else {
        return{
          ...state,
          submitted: false,
          error: true
        };
      }
    }
    case FETCH_PROFILE_DETAILS_ERROR: {
      return{
        ...state,
        submitted: false,
        error: true
      };
    }
    case EDIT_PROFILE_DETAILS_STARTED: {
      return{
        ...state,
        submitted: false,
      };
    }
    case EDIT_PROFILE_DETAILS_COMPLETED: {
      let key = action.payLoad;
      let data = action.profileData;
      state.profile[key] = data;
      return{
        ...state,
        profile: {...state.profile},
        submitted: false,
        success: true
      };
    }
    case EDIT_PROFILE_DETAILS_ERROR: {
      return{
        ...state,
        submitted: false,
        success: true
      };
    }
    default:
      return state;
  }
}

export default profileReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/profileReducer.js